'use strict';

const EventEmitter = require('wolfy87-eventemitter');

const CHANNEL_NAME = 'LOCAL_CHANNEL';

const BACK_TO_INBOX = 'BACK_TO_INBOX';
const ACCEPT_INVITATION = 'ACCEPT_INVITATION';

class LocalChannel extends EventEmitter {

    constructor () {
        super();

        if (typeof BroadcastChannel !== 'undefined') {
            this.channel = new BroadcastChannel(CHANNEL_NAME);
            this.channel.onmessage = this._onMessage.bind(this);
        }
    }

    backToInbox (data) {
        if (this.channel) {
            this.channel.postMessage({
                type: BACK_TO_INBOX,
                data
            });
        }
    }

    acceptInvitation (data) {
        if (this.channel) {
            this.channel.postMessage({
                type: ACCEPT_INVITATION,
                data
            });
        }
    }

    _onMessage (event) {
        switch (event.data.type) {
        case BACK_TO_INBOX:
            this.emit(BACK_TO_INBOX, event.data.data);
            break;
        case ACCEPT_INVITATION:
            this.emit(ACCEPT_INVITATION, event.data.data);
            break;
        default:
            break;
        }
    }

}

module.exports = LocalChannel;


// WEBPACK FOOTER //
// ./src/LocalChannel.js